import Vue from 'vue';
import { dateFilter } from './date.filter';
import { decimalFilter } from './decimal.filter';
import { listOptionsFilter } from './list-options.filter';
import { highlightFilter } from './highlight.filter';
import { boolFilter } from './bool.filter';
import { moneyFilter } from './money.filter';

Vue.filter('listOptions', listOptionsFilter);
Vue.filter('decimal', decimalFilter);
Vue.filter('date', dateFilter);
Vue.filter('bool', boolFilter);
Vue.filter('highlight', highlightFilter);
Vue.filter('money', moneyFilter);
